<div class="shadow-level-2 mb-20" [class.bg-white]="!(isLoading | async)">
    <div class="py-12 px-8 flex justify-between items-center border-b border-solid border-neutral-extra-light">
        <div>
            <div *ngIf="!(isLoading | async) || !config?.showTitleLoader" class="text-header-5">
                {{ config?.title }}
            </div>
            <div class="shimmer w-[250px] h-20" *ngIf="(isLoading | async) && config?.showTitleLoader"></div>
            <div *ngIf="config?.label" class="text-label-2 text-secondary-main mr-12">
                <div *ngIf="!(isLoading | async)">{{ config?.label }}</div>
                <div class="shimmer w-150 h-12" *ngIf="isLoading | async"></div>
            </div>
        </div>
        <div *ngIf="config?.hasButton">
            <shared-ui-button
                [color]="'accent'"
                [appearance]="'outline'"
                (click)="btnClick.emit(config?.data)"
                [loading]="isLoading | async"
            >
                {{ config?.buttonText }}
            </shared-ui-button>
        </div>
    </div>

    <div>
        <ng-content select="[content]"></ng-content>
    </div>
</div>
